<div class="d-flex flex-column">
    <label *ngIf="label" class="form-control-label">
        {{ label }}
    </label>
    <ul class="form-check list-group">
        <li class="list-group-item" *ngFor="let item of items">
            <sume-checkbox
                [formGroup]="formGroup"
                [controlName]="item.controlName"
                [label]="item.label"
                [labelOnTop]="false">
            </sume-checkbox>
        </li>
    </ul>
    <div class="text-danger" *ngIf="isInvalid">
        <small>
            <span>{{ message }}</span>
        </small>
    </div>
</div>
